import React from 'react';

import { appReactMemo } from 'hocs';

import { useFilterContext } from '../FilterContext';
import { IOpenSidebarParams } from '../utils/types';

import AppliedFiltersList from './AppliedFiltersList';

const AppliedFilters = () => {
  const {
    config,
    filters,
    gridColumnsSettings,
    onOpenSidebar,
    onPageFiltersChange,
    removeFilter,
    toggleFilterEnabled,
  } = useFilterContext();

  const onRemoveFilter = React.useCallback(
    (columnKey: string, index?: number, isAdditional?: boolean) =>
      (e: React.MouseEvent) => {
        e.stopPropagation();
        const removeResult = removeFilter({
          columnKey,
          index,
          isAdditional,
          resetCanFilter: false,
        });
        onPageFiltersChange?.({ filters: removeResult, gridColumnsSettings });
      },
    [removeFilter, gridColumnsSettings, onPageFiltersChange],
  );

  const onToggleFilter = React.useCallback(
    (columnKey: string, index?: number, isAdditional?: boolean) =>
      (e: React.MouseEvent) => {
        e.stopPropagation();
        const toggleResult = toggleFilterEnabled({ columnKey, index, isAdditional });
        onPageFiltersChange?.({ filters: toggleResult, gridColumnsSettings });
      },
    [toggleFilterEnabled, gridColumnsSettings, onPageFiltersChange],
  );

  const onClickFilter = ({ columnKey, index, isAdditional }: IOpenSidebarParams) => {
    onOpenSidebar({
      columnKey,
      index,
      isAdditional,
    });
  };

  return (
    <AppliedFiltersList
      config={config}
      filters={filters}
      onClickFilter={onClickFilter}
      onRemoveFilter={onRemoveFilter}
      onToggleFilter={onToggleFilter}
    />
  );
};

export default appReactMemo(AppliedFilters);
